import { Grid2, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import Social from 'src/components/Social';
import type { SocialItem } from 'src/global/types/common.type';

const Footer = () => {
  const [socials] = useState<SocialItem[]>([
    { href: 'https://x.com/LFGincorporated', src: '/icons/socials/x.svg', alt: 'x' },
    { href: 'https://discord.gg/PjTfVJh4Wr', src: '/icons/socials/discord.svg', alt: 'discord' },
    { href: 'https://www.linkedin.com/company/lfg-incorporated/', src: '/icons/socials/linkedin.svg', alt: 'linkedin' },
    { href: 'https://www.youtube.com/@lfginc', src: '/icons/socials/youtube.svg', alt: 'youtube' },
  ]);

  return (
    <Stack paddingY={3} width={'100%'} component={'footer'} alignItems={'center'} justifyContent={'center'}>
      <Stack
        gap={{ xs: 3, sm: 2 }}
        width={'min(1344px, 100%)'}
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={'center'}
        justifyContent={'space-between'}
        paddingX={{ lg: 0, xs: 2 }}>
        <Grid2 spacing={{ xs: 1, sm: 2 }} container width={{ xs: '100%', sm: '50%' }}>
          <Grid2 size={{ xs: 6, sm: 3 }}>
            <Typography color={'#FFFFFF59'} textTransform={'capitalize'} fontSize={{ xs: '12px', sm: '14px' }}>
              All Rights Reserved
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 6, sm: 3 }}>
            <a href={'https://lfg.inc/terms'} target={'_blank'}>
              <Typography
                color={'#FFFFFF59'}
                textTransform={'capitalize'}
                fontSize={{ xs: '12px', sm: '14px' }}
                width={'100%'}>
                Terms & Conditions
              </Typography>
            </a>
          </Grid2>
          <Grid2 size={{ xs: 6, sm: 3 }}>
            <a href={'https://lfg.inc/privacy'} target={'_blank'}>
              <Typography color={'#FFFFFF59'} textTransform={'capitalize'} fontSize={{ xs: '12px', sm: '14px' }}>
                Privacy Policy
              </Typography>
            </a>
          </Grid2>
          <Grid2 size={{ xs: 6, sm: 3 }}>
            <a href={'https://support.lfg.inc'} target={'_blank'}>
              <Typography color={'#FFFFFF59'} textTransform={'capitalize'} fontSize={{ xs: '12px', sm: '14px' }}>
                Support Center
              </Typography>
            </a>
          </Grid2>
        </Grid2>
        <Stack
          width={{ xs: '100%', sm: 'fit-content' }}
          gap={5}
          alignItems={'center'}
          direction={'row'}
          justifyContent={{ xs: 'space-between', sm: 'flex-end' }}>
          <a href={'https://lfg.inc'} target={'_blank'} style={{ lineHeight: 0 }}>
            <img alt={'lfg'} src={'/icons/LFGLogo.svg'} className={'w-[151px] h-[30px] sm:w-[162px] sm:h-[32px]'} />
          </a>
          <Stack gap={2} alignItems={'center'} direction={'row'}>
            {socials.map(social => (
              <Social key={social.alt} {...social} className={'w-[24px] h-[24px] sm:w-[32px] sm:h-[32px]'} />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Footer;
